<!-- Component can be used in microscope and periscope -->
<template>
  <div class="linear-activity">
    <div class="indeterminate" />
  </div>
</template>

<style scoped lang="scss">
.linear-activity {
  overflow: hidden;
  width: 100%;
  height: 2px;
  background-color: var(--color-accent-subtle);
}

.indeterminate {
  position: relative;
  width: 100%;
  height: 100%;
}

.indeterminate:before {
  content: '';
  position: absolute;
  height: 100%;
  background-color: var(--color-accent-fg);
  animation: indeterminate_first 1.5s infinite ease-out;
}

.indeterminate:after {
  content: '';
  position: absolute;
  height: 100%;
  background-color: var(--color-accent-fg);
  animation: indeterminate_second 1.5s infinite ease-in;
}

@keyframes indeterminate_first {
  0% {
    left: -100%;
    width: 100%;
  }

  100% {
    left: 100%;
    width: 10%;
  }
}

@keyframes indeterminate_second {
  0% {
    left: -150%;
    width: 100%;
  }

  100% {
    left: 100%;
    width: 10%;
  }
}
</style>
